// Single global audio element for 30s previews
let current = null;
let currentUrl = null;
const listeners = new Set();

function notify() {
  listeners.forEach((l) => l(currentUrl));
}

export function togglePreview(url) {
  if (!url) return;
  if (currentUrl === url && current && !current.paused) {
    current.pause();
    currentUrl = null;
    notify();
    return;
  }
  if (current) {
    current.pause();
  }
  current = new Audio(url);
  currentUrl = url;
  current.play().catch(() => {});
  current.onended = () => {
    currentUrl = null;
    notify();
  };
  notify();
}

export function stopPreview() {
  if (current) current.pause();
  currentUrl = null;
  notify();
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function playingUrl() {
  return currentUrl;
}
